module.exports = __webpack_public_path__ + "static/media/Mint-Guarantee.1b3d06ce.png";